import { TermsCondtionsComponent } from './../terms-condtions/terms-condtions.component';
import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OnBoardingComponent } from '../on-boarding/on-boarding.component';
import { LoginComponent } from '../login/login.component';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { UtilsService } from 'src/app/core/services/utils.service';
import { SignUp } from 'src/app/core/interface/auth.model';
import { AuthService } from '../../../core/services/auth.service';
import { SearchCountryField, TooltipLabel, CountryISO } from 'ngx-intl-tel-input';
import { NgxSpinnerService } from "ngx-spinner";
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { DisclaimerComponent } from '../disclaimer/disclaimer.component';
import { PrivacyPolicyComponent } from '../privacy-policy/privacy-policy.component';
declare let fbq: Function;

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.scss']
})
export class SignUpComponent implements OnInit {
  @Input() type: any = 'signup';
  @Input() createdUser;
  signupForm: FormGroup;

  errorMessage: string;

  submitted: boolean = false;
  isError: boolean = false;

  separateDialCode = true;
  password = 'password';
  cpassword = 'password';
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  userData: any;
  redirectUrl = '/dashboard';

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private utilService: UtilsService,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private router: Router,
  ) { }

  ngOnInit() {

    this.signupForm = this.formBuilder.group({
      name: ['', Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.NAME_PATTERN), this.noWhitespaceValidator, Validators.maxLength(45)])],
      email: ['', Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.EMAIL_PATTERN)])],
      password: ['', Validators.compose([Validators.required, Validators.minLength(6), Validators.pattern(REGEX_PATTERNS.PASSWORD_PATTERN), this.noWhitespaceValidator])],
      password_confirmation: ['', Validators.compose([Validators.required, Validators.pattern(REGEX_PATTERNS.PASSWORD_PATTERN), this.noWhitespaceValidator])],
    }, {
      validator: this.utilService.mustMatch('password', 'password_confirmation')
    });
  }
  closeDialog() {
    this.activeModal.close();
    this.router.navigateByUrl(this.redirectUrl);
  }

  openConfirmEmail() {
    this.type = 'confirm';
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  openOnboardModal() {
    this.closeDialog();
    this.modalService.open(OnBoardingComponent, { size: 'lg', centered: true });
  }
  openLoginModal() {
    this.closeDialog();
    this.modalService.open(LoginComponent, { size: 'lg', centered: true });
  }

  openTermsAndConditionModal() {
    // this.closeDialog();
    this.modalService.open(TermsCondtionsComponent, { size: 'lg', centered: true });
  }

  openDisclaimerModal() {
    this.modalService.open(DisclaimerComponent, { size: 'lg', centered: true });
  }

  openPrivacyPolicyModal() {
    this.modalService.open(PrivacyPolicyComponent, { size: 'lg', centered: true });
  }

  onSubmit() {
    
    this.submitted = true;
    this.signupForm.value.name.trim();
    if (this.signupForm.invalid) {
      return;
    }
    this.spinner.show();
    const params: SignUp = {
      'user': { ...this.signupForm.value }
    };
    params.user.name = params.user.name.trim();
    params.user.password = this.utilService.encode(params.user.password);
    params.user.password_confirmation = this.utilService.encode(params.user.password_confirmation);
    params.user.acceptTerms = true;

    this.authService.signUp(params).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success) {
          this.userData = response.data.user;
          fbq('trackCustom', 'SignUp');
          this.openConfirmEmail();
        }
        else if (response.status == 422) {
          this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.EMAIL_ALREADY_TAKEN;
          this.isError = true;
        }
      }, (error: any) => {
        this.spinner.hide();
        this.errorMessage = LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
        this.isError = true;
      });
  }
  togglePassword() {
    if (this.password == 'text') {
      this.password = 'password';
    } else {
      this.password = 'text';
    }
  }

  toggleCPassword() {
    if (this.cpassword == 'text') {
      this.cpassword = 'password';
    } else {
      this.cpassword = 'text';
    }
  }
}

